import { render, staticRenderFns } from "./TechnicalError.vue?vue&type=template&id=226118fa&scoped=true"
import script from "./TechnicalError.vue?vue&type=script&lang=js"
export * from "./TechnicalError.vue?vue&type=script&lang=js"
import style0 from "./TechnicalError.vue?vue&type=style&index=0&id=226118fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226118fa",
  null
  
)

export default component.exports